import React from "react";
import { Icon, Image } from "semantic-ui-react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Draggable } from "react-beautiful-dnd";
import { observer } from "mobx-react";

const ReviewPhoto = observer(
  ({
    photoEditingPhotoId,
    isSelected,
    url,
    thumbnailUrl,
    isHdrCapable,
    fileName,
    index,
    togglePhotoEditingPhotoSelectionCallback,
  }) => (
    <Draggable draggableId={photoEditingPhotoId} index={index}>
      {provided => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={cx({ "review-image": true, selected: isSelected })}
        >
          <Image
            src={thumbnailUrl || url}
            onClick={event => {
              // stop propagation so the body event listener doesn't unselect all images.
              // See ReviewImages.jsx 's event listener.
              event.stopPropagation();
              togglePhotoEditingPhotoSelectionCallback();
            }}
          />
          {!isHdrCapable && (
            <span className="review-warning">
              <Icon name="warning sign" />
            </span>
          )}
          <span className="review-name">{fileName}</span>
        </div>
      )}
    </Draggable>
  ),
);

ReviewPhoto.propTypes = {
  // for some reason if we pass the entire photoEditingPhoto object this react component won't update
  // when the isSelected property is toggled. Passing each individual property fixes it.
  photoEditingPhotoId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isSelected: PropTypes.bool,
  url: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  isHdrCapable: PropTypes.bool,
  fileName: PropTypes.string.isRequired,
  togglePhotoEditingPhotoSelectionCallback: PropTypes.func.isRequired,
  index: PropTypes.number,
};

export default ReviewPhoto;
